import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsPage from "@/pages/TermsPage";

// Public build: only the /invest lead form and its legal pages are reachable.
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/invest" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<Navigate to="/invest" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
